import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import undoable from 'redux-undo'

import articleReducer from './Slices/Kiosk/ArticleSlice'
import tableOptionsReducer from './Slices/Kiosk/TableOptionsSlice'
import languageReducer from './Slices/LanguageSlice'
import quantitiesReducer from './Slices/Kiosk/QuantitiesSlice'
import configurationReducer from './Slices/ConfigurationSlice'
import movementsAvailabilitiesReducer from './Slices/Kiosk/MovementsAvailabilitiesSlice'
import articleDetailReducer from './Slices/Kiosk/ArticleDetailSlice'
import marketplaceAvailabiltiesReducer from './Slices/Kiosk/MarketplaceAvailabilitiesSlice'
import seasonRuleFilterSliceReducer from './Slices/Omnichannel/SeasonRuleSlice'
import discountSliceReducer from './Slices/Omnichannel/DiscountSlice'
import channelSliceReducer from './Slices/Settings/ChannelSlice'
import subRuleSliceReducer from './Slices/Omnichannel/SubRuleSlice'
import gridLayoutSliceReducer from './Slices/Kiosk/GridLayoutSlice'
import priceSliceReducer from './Slices/Kiosk/PriceSlice'
import lockSliceReducer from './Slices/Omnichannel/LockSlice'

import imagesReducer from './Slices/PIM/ImagesSlices'
import galleriesReducer from './Slices/Settings/GalleriesSlice'
import siteSliceReducer from './Slices/Settings/SiteSlice'
import storeSliceReducer from './Slices/Settings/StoreSlice'
import settingsSliceReducer from './Slices/Settings/SettingsSlice'
import { isProdSite } from './Helpers/GenericHelpers'

const store = configureStore({
  devTools: !isProdSite(),
  reducer: undoable(
    combineReducers({
      article: articleReducer,
      tableOptions: tableOptionsReducer,
      language: languageReducer,
      quantities: quantitiesReducer,
      configuration: configurationReducer,
      movementsAvailabilities: movementsAvailabilitiesReducer,
      articleDetail: articleDetailReducer,
      marketplaceAvailabilities: marketplaceAvailabiltiesReducer,
      seasonRule: seasonRuleFilterSliceReducer,
      discount: discountSliceReducer,
      channel: channelSliceReducer,
      subRule: subRuleSliceReducer,
      dynamicGrid: gridLayoutSliceReducer,
      price: priceSliceReducer,
      images: imagesReducer,
      galleries: galleriesReducer,
      locks: lockSliceReducer,
      site: siteSliceReducer,
      store: storeSliceReducer,
      settings: settingsSliceReducer,
    }),
    {
      filter: filterActions,
      ignoreInitialState: true,
    },
  ),
})

export default store

function filterActions(action, currentState, previousHistory) {
  var condition =
    !(action.type === 'language/loadLanguage' && previousHistory.past.length === 0) &&
    [
      'language/loadLanguage',
      'article/saveArticles',
      'tableOptions/saveColumnsAndExtraColumns',
      'quantities/saveFilter',
      'movementsAvailabilities/saveAvailabilitiesFilter',
      'articleDetail/setArticleQuantities',
      'articleDetail/setArticleAvailabilities',
      'articleDetail/setArticleMovements',
      'articleDetail/setArticleMarketplaceAvailabilities',
      'articleDetail/setArticleEnabledMarketplace',
      'articleDetail/setArticlePriceData',
      'articleDetail/setArticleQuantityLimitData',
    ].indexOf(action.type) !== -1 // only add to history if action is SOME_ACTION
  return condition
}

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
